import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import { useAtom } from "jotai";
import { FC, useState } from "react";
import { modalDeleteDelivery } from "../../../atoms/atom";
import { DocumentsService } from "../../../services/DocumentService";
import { DeliveryDocumentDTO } from "../../../types/DeliveryDocumentDTO";
import { useAlert } from "../../contextProviders/AlertProvider";

interface DeleteDeliveryProps {
	dto: DeliveryDocumentDTO;
}

const DeleteDeliveryModal: FC<DeleteDeliveryProps> = (props: DeleteDeliveryProps) => {
	const [open, setOpen] = useAtom(modalDeleteDelivery);
	const [loading, setLoading] = useState(false);
	const { showAlert, showError } = useAlert();

	return (
		<Dialog
			open={open}
			onClose={() => setOpen(false)}
			id='modal-delete-delivery'
		>
			<DialogTitle>Excluir envio pendente</DialogTitle>
			<DialogContent>
				<Typography>
					Você confirma a exclusão do envio pendente do tipo {props.dto.deliveryType} para {props.dto.destinatary}?
				</Typography>
				<Typography sx={{marginTop: "1vh"}}>
					Os documentos anexados a este envio também serão excluídos.
				</Typography>
			</DialogContent>
			<DialogActions>
				<Button id="delete-close-button" onClick={() => setOpen(false)}>
					Cancelar
				</Button>
				<Button
					id="delete-button"
					color="error"
					variant="contained"
					onClick={() => remove()}
					disabled={loading}
				>
					{loading
						? <CircularProgress sx={{color: "#48a7dbff"}} size={'20px'}/>
						: "Excluir"
					}
				</Button>
			</DialogActions>
		</Dialog>
	);

	async function remove() {
		setLoading(true);
		try {
			const response = await new DocumentsService().deleteDelivery(props.dto.id);
			if (response.status === 200) {
				showAlert('Envio pendente excluído com sucesso');
				setOpen(false);
			}
		} catch (error) {
			showError();
		} finally {
			setLoading(false);
		}
	}
}

export default DeleteDeliveryModal;